import './DrawingPage.css';
import React, { useContext, useEffect } from 'react';
import DrawingCanvas from "../components/DrawingCanvas";
import { SocketContext } from '../components/SocketContext';

const DrawingPage = () => {
  const socket = useContext(SocketContext);

  useEffect(() => {
    
  }, [socket]);

  function handleClick(){
    if (socket){
      socket.emit("joinroom", {"room": "Red", "username": "testuser"});
    }
  }

  return (
    <div className="DrawingPage">
      {socket ? (
        <>
          <button onClick={handleClick}>Joinroom</button>
          <DrawingCanvas />
          
        </>
      ) : <div>Connecting...</div>}
    </div>
  );
};

export default DrawingPage;

